<form nz-form style="padding-top:12px;padding-right:12px" autocomplete="off">
  <div nz-row [nzGutter]="['0','0']">
      <div nz-col nzSm="24" nzMd="24"> 
        <nz-form-item>
          <nz-form-label nzSpan="24" nzRequired>Lĩnh vực</nz-form-label>
          <nz-form-control nzSpan="24" nzErrorTip="Nhập trường thông tin bắt buộc">
            <asc-autocomplete [ascModel]="LevelOfDevelopmentTypesControl" (ascModelChange)="changeLevelOfDevelopmentTypes($event)"
              [placeholder]="'Chọn lĩnh vực...'" [getListAC]="getLevelOfDevelopmentTypesACFn">
            </asc-autocomplete>
          </nz-form-control>
        </nz-form-item>
      </div>
      <div nz-col nzSm="24" nzMd="24">
        <nz-form-item>
          <nz-form-label nzSpan="24" nzRequired>Mức độ phát triển</nz-form-label>
          <nz-form-control nzSpan="24" nzErrorTip="Nhập trường thông tin bắt buộc">
            <asc-autocomplete [ascModel]="LevelOfDevelopmentControl" (ascModelChange)="changeLevelOfDevelopment($event)"
              [placeholder]="'Chọn mức độ phát triển...'" [getListAC]="getLevelOfDevelopmentACFn">
            </asc-autocomplete>
          </nz-form-control>
        </nz-form-item>
      </div>
  </div>
  <div *nzModalFooter>
    <div *ngIf="!isEditMode" class="card-footer text-right" >
      <button nz-button (click)="close()" [disabled] = "isDisabled">Đóng</button>&nbsp;
      <button nz-button nzType="primary" (click)="UpdateClose()" [disabled]="isDisabled" type="submit">Lưu & Đóng</button>
    </div>
    <div *ngIf="isEditMode" class="card-footer text-right">
        <button nz-button (click)="close()" [disabled] = "isDisabled">Đóng</button>&nbsp;
        <button nz-button nzType="primary" (click)="UpdateClose()" [disabled]="isDisabled" type="submit">Sửa</button>
    </div>
  </div>
</form>